module.exports = __webpack_public_path__ + "static/media/1.61f99a93.jpg";